<!-- 🌌 Fondo galáctico detalle producto -->
<section
  class="relative min-h-screen bg-obsidian px-4 py-16 overflow-hidden"
>
  <!-- 💫 Efecto de luz dorada en fondo -->
  <div
    class="absolute w-[600px] h-[600px] bg-champagne-gold opacity-10 rounded-full blur-3xl animate-spin-slow top-1/3 left-1/2 -translate-x-1/2 -translate-y-1/2 z-0"
  ></div>

  <!-- 📦 Contenido principal -->
  <div class="relative z-10 max-w-6xl mx-auto">
    <!-- Contenedor principal con manejo de estado -->
    @switch (state.status) {
      <!-- ✅ Estado Success -->
      @case ("success") {
        @if (state.product; as product) {
          <div>
            <!-- Breadcrumb y título -->
            <div class="mb-10 text-silk-ivory animate-fade-slide-up">
              <nav class="text-silk-ivory/70 text-sm">
                <ol class="flex space-x-2">
                  <li>
                    <a routerLink="/" class="hover:underline text-champagne-gold"
                      >Home</a
                    >
                  </li>
                  <li>/</li>
                  <li>
                    <a
                      routerLink="/tienda"
                      class="hover:underline text-champagne-gold"
                      >Tienda</a
                    >
                  </li>
                  <li>/</li>
                  <li class="truncate max-w-xs">{{ product.name }}</li>
                </ol>
              </nav>
            </div>
            <!-- Tarjeta del producto -->
            <app-galaxy-card
              [hoverEffect]="false"
              class="animate-fade-slide-up bg-obsidian-surface border border-champagne-gold/20 shadow-gold-glow"
              padding="lg"
            >
              <div
                galaxy-card-content
                class="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12"
              >
                <!-- Imagen del producto con Zoom -->
                <div
                  class="image-zoom-container bg-obsidian rounded-xl overflow-hidden border border-champagne-gold/10 p-4"
                  (mousemove)="onMouseMove($event)"
                  (mouseleave)="onMouseLeave()"
                >
                  <img
                    #productImage
                    [src]="product.imageUrl"
                    [alt]="product.name"
                    class="w-full h-full object-contain rounded-xl shadow-md drop-shadow-2xl transition-transform duration-300 ease-out"
                  />
                </div>
                <!-- Detalles -->
                <div class="flex flex-col">
                  <h1
                    class="text-3xl lg:text-4xl font-serif font-bold mb-3 leading-tight text-silk-ivory"
                  >
                    {{ product.name }}
                  </h1>
                  <p class="text-silk-ivory/60 text-sm mb-2">
                    Categoría: {{ product.categoryName }}
                  </p>

                  <!-- Precio Dinámico según Formato Seleccionado -->
                  <div class="my-3">
                    @if (selectedFormat) {
                      <span
                        class="text-champagne-gold text-4xl lg:text-5xl font-serif font-bold tracking-tighter"
                        >${{ selectedFormat.price | number: "1.0-0" }}</span
                      >
                      <span class="ml-3 text-xs uppercase px-2.5 py-1 bg-champagne-gold/20 text-champagne-gold rounded-full font-semibold border border-champagne-gold/30">
                        {{ selectedFormat.formatName }}
                      </span>
                    } @else {
                      <span
                        class="text-champagne-gold text-4xl lg:text-5xl font-serif font-bold tracking-tighter"
                        >${{ product.price | number: "1.0-0" }}</span
                      >
                    }
                  </div>

                  <!-- Selector de Formato (5ml, 10ml, Full Bottle) -->
                  @if (product.formats && product.formats.length > 0) {
                    <div class="my-4">
                      <label class="block text-sm font-semibold text-silk-ivory/90 mb-2.5">
                        Selecciona el Formato / Presentación:
                      </label>
                      <div class="grid grid-cols-1 sm:grid-cols-3 gap-3">
                        @for (fmt of product.formats; track fmt.formatKey) {
                          <button
                            type="button"
                            (click)="selectFormat(fmt)"
                            class="p-3 rounded-xl border text-left transition flex flex-col justify-between cursor-pointer"
                            [class.border-champagne-gold]="selectedFormat?.formatKey === fmt.formatKey"
                            [class.bg-champagne-gold/10]="selectedFormat?.formatKey === fmt.formatKey"
                            [class.border-white/15]="selectedFormat?.formatKey !== fmt.formatKey"
                            [class.bg-obsidian/50]="selectedFormat?.formatKey !== fmt.formatKey"
                            [class.hover:border-champagne-gold/50]="selectedFormat?.formatKey !== fmt.formatKey"
                          >
                            <span class="font-bold text-silk-ivory text-xs sm:text-sm">{{ fmt.formatName }}</span>
                            <span class="text-champagne-gold font-semibold mt-1 text-sm">${{ fmt.price | number: "1.0-0" }}</span>
                          </button>
                        }
                      </div>
                      @if (selectedFormat?.description) {
                        <p class="text-xs text-silk-ivory/60 mt-2 italic">
                          💡 {{ selectedFormat?.description }}
                        </p>
                      }
                    </div>
                  }

                  <div class="flex-grow">
                    <h3
                      class="text-lg font-serif font-semibold border-b border-champagne-gold/20 pb-2 mb-3 text-silk-ivory"
                    >
                      Descripción de la Fragancia
                    </h3>
                    <p class="text-silk-ivory/80 mb-4 leading-relaxed text-sm">
                      {{ product.description }}
                    </p>
                  </div>

                  <!-- Sellos de Confianza Institucional & Blindaje Jurídico (SIC / Ley 1480 / Decisión 486 CAN) -->
                  <div class="my-4 p-4 bg-obsidian border border-champagne-gold/20 rounded-xl space-y-2.5 text-xs text-silk-ivory/80">
                    <div class="flex items-center gap-2 font-medium text-champagne-gold">
                      <span>🛡️</span> Garantía de Autenticidad 100% Original (Casas Árabes Oficiales)
                    </div>
                    <div class="flex items-center gap-2 font-medium text-champagne-gold">
                      <span>🇨🇴</span> Envíos Seguros a Todo Colombia & Pago Contra Entrega en Bogotá
                    </div>
                    <p class="text-silk-ivory/60 leading-relaxed text-justify pt-2 border-t border-champagne-gold/10">
                      <strong class="text-silk-ivory/80">Aviso Legal (Art. 54 Decisión 486 CAN):</strong> Producto original fraccionado de manera independiente por Altair Parfum. Las marcas de referencia pertenecen a sus titulares y se mencionan con fines estrictamente descriptivos.
                    </p>
                  </div>

                  <!-- Acciones de Compra -->
                  <div
                    class="mt-auto pt-6 border-t border-champagne-gold/20 flex flex-col sm:flex-row items-center gap-4"
                  >
                    <!-- Selector de cantidad -->
                    <div
                      class="flex items-center rounded-full border border-white/20"
                    >
                      <button
                        (click)="quantity = quantity > 1 ? quantity - 1 : 1"
                        appGalaxyButton
                        appGalaxyRipple
                        galaxyVariant="ghost"
                        class="!rounded-r-none !px-5 !py-3"
                      >
                        -
                      </button>
                      <input
                        type="number"
                        id="quantity"
                        name="quantity"
                        [(ngModel)]="quantity"
                        min="1"
                        max="99"
                        class="w-16 text-center bg-transparent border-x border-white/20 py-3 text-white font-semibold focus:outline-none"
                      />
                      <button
                        (click)="quantity = quantity + 1"
                        appGalaxyButton
                        appGalaxyRipple
                        galaxyVariant="ghost"
                        class="!rounded-l-none !px-5 !py-3"
                      >
                        +
                      </button>
                    </div>
                    <!-- Botón de acción -->
                    <button
                      (click)="addCart()"
                      [disabled]="isAddingToCart"
                      appGalaxyButton
                      appGalaxyRipple
                      galaxyVariant="primary"
                      galaxySize="lg"
                      class="w-full sm:w-auto flex-grow"
                      [class.bg-green-500]="isAddingToCart"
                      [class.hover:bg-green-600]="isAddingToCart"
                    >
                      @if (!isAddingToCart) {
                        <span>Añadir al Carrito</span>
                      }
                      @if (isAddingToCart) {
                        <span>¡Añadido! ✔</span>
                      }
                    </button>
                  </div>
                </div>
              </div>
            </app-galaxy-card>
          </div>
        }
      }
      <!-- 🔄 Estado Loading -->
      @case ("loading") {
        <div class="flex justify-center items-center py-32">
          <div class="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-cyan-400"></div>
        </div>
      }
      <!-- ❌ Estado Error -->
      @case ("error") {
        <div class="text-center py-32 text-white">
          <p class="text-xl text-red-400 mb-4">{{ state.error }}</p>
          <a routerLink="/tienda" appGalaxyButton appGalaxyRipple galaxyVariant="primary">
            Volver a la Tienda
          </a>
        </div>
      }
    }
  </div>
</section>
